import __base_store from '@/store/__base_store'

/**
 * Store de plantillas para el PDF de ofertas de artículos (modelo `article_pdf`).
 */
export default __base_store({
	state: {
		model_name: 'article_pdf',
	},
})
